import { StrTool } from '@es-tool/core'

/**
 * 空响应错误
 * @author LL
 * @date 2022-01-20 上午 10:28
 **/
export class EmptyResponseError extends Error {
    public override name: string
    public override message: string
    private readonly NAME = '空响应错误'

    constructor(message: string = StrTool.EMPTY, name?: string) {
        super(message)
        this.message = message
        this.name = name as string || this.NAME
    }
}
